module.exports = __webpack_public_path__ + "static/img/090_TO8_1755_og.178bbb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/090_TO8_1755_og.jpg
// module id = N880
// module chunks = 0